import type { HTMLAttributes, ReactNode } from 'react'
import React from 'react'
import { csx, Text } from '@vtex/admin-ui'

export type ProductNameProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode
}

export const ProductName = ({ children, ...props }: ProductNameProps) => (
  <div
    className={csx({ marginBottom: '$space-8' })}
    data-testid="product-name"
    {...props}
  >
    <Text variant="display">{children}</Text>
  </div>
)
